import { Item, Toolbar } from  'devextreme-react/data-grid';
import { t } from 'i18next';
import { forwardRef, useMemo } from "react";
import { Button } from 'devextreme-react/button';

import {  useCallback,useRef, useState,useImperativeHandle} from 'react'
import { confirm } from 'devextreme/ui/dialog';
import { bool } from 'yup';
import { checkPermission } from '@/modules/auth';
interface GridToolbarParams
{        
    
    delete_api?: (x:string)=>Promise<any>; 
    gridRef:any;
    canRemove?:boolean,
    canUpdate?:boolean,
    canAddNew?:boolean,
    canChoseColumn?:boolean,    
    CheckPermision:()=> ToolBarPermissions;
    
}
interface ToolBarPermissions
{
    canRemove?:boolean,
    canUpdate?:boolean,
    canAddNew?:boolean,
}

const GridToolbar = (props:GridToolbarParams)=> {

    const [canUpdate,setCanUpdate]=useState<boolean|undefined>(props.canUpdate);
    const [canAddNew,setCanAddNew]=useState<boolean|undefined>(props.canAddNew);
    const [canRemove,setCanRemove]=useState<boolean|undefined>(props.canRemove);
    const [canChoseColumn,setChoseColumn]=useState<boolean|undefined>(props.canChoseColumn);
    const CheckPermisions=()=>{
        var p = props.CheckPermision();       
        setCanAddNew( p.canAddNew);
        setCanRemove(p.canRemove);        
    }

    const btnListOptions = useMemo(() => ({
        icon: 'refresh',
        text:t("syncflow:btn_list"),
        onClick: () => {
            
            if (props.gridRef.current?.instance.hasEditData()) {
                let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
                result.then((dialogResult) => 
                    {
                        {
                            if (dialogResult) 
                                {
                                    props.gridRef.current?.instance.saveEditData().then(() => 
                                        {
                                            
                                            props.gridRef.current?.instance.cancelEditData();
                                            props.gridRef.current?.instance.refresh();
                                                    

                                        });
                                }
                            else 
                                {
                                    props.gridRef.current?.instance.cancelEditData();
                                    props.gridRef.current?.instance.refresh();
                                    
                                    CheckPermisions();
                                }
                        }                
                    });
            }
            else 
            {            
                props.gridRef.current?.instance.refresh();
                CheckPermisions();
            }
            /*
            setCanUpdate(props.canUpdate);
            setCanAddNew(props.canAddNew);    
            setCanRemove(props.canRemove);    
        */
        },
      }), []);
    const btnSaveOptions = useMemo(() => ({
            icon: 'save',
            text:t("syncflow:btn_save"),
            onClick: () => {
                 if (props.gridRef.current?.instance.hasEditData()) 
                                {
                                    let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
                                    result.then((dialogResult) => {
                                        if (dialogResult) {
                                            {
                                                props.gridRef.current?.instance.saveEditData().then(() => {
                                                 
                                                 props.gridRef.current?.instance.refresh().then(() =>  
                                                     {
                                                        props.gridRef.current?.instance.cancelEditData();
                                                     });
                                            });
                                        }
                                        }
                                    });
                                }

            },
          }), []);
    const btnAddNewOptions = useMemo(() => ({icon: 'add',text:t("syncflow:btn_new"),
    onClick: () => {
        props.gridRef.current?.instance.addRow();

    },
    }), []);
    const btnColumnChoserOptions = useMemo(() => ({icon: 'columnchooser',text: 'Columns',
        onClick: () => {
            props.gridRef.current?.instance.showColumnChooser();
    
        },
        }), []);
          
    const btnRemoveOptions = useMemo(() => ({icon: 'remove', text:t("syncflow:remove_selected"),
        onClick: () => {
            let selectedRowKeys= props.gridRef.current?.instance.getSelectedRowKeys();
            if (selectedRowKeys && selectedRowKeys.length > 0) {
                        let result = confirm(t("syncflow:msg_delete"), t("syncflow:ti_confirm"));
                        result.then((dialogResult) => {
                          
                            if (dialogResult) {
            
                                console.log( selectedRowKeys);
                                if(props.delete_api)
                                    props.delete_api(selectedRowKeys).then((response:any) => {
                                        props.gridRef.current?.instance.refresh();
                                        //toast.success(t("syncflow:msg_saved"));
                                    })
                                // selectedRowKeys.forEach((e: any) => {
                                  
                                //         if(props.delete_api)
                                //             props.delete_api(e).then((response:any) => {
                                //                 //dataGridRef.current?.instance.refresh();
                                //                 //toast.success(t("syncflow:msg_saved"));
                                //             })
                                    
                                // });
            
                            }
                        });
                    }

        },
    }), []);

return ( 
<Toolbar> 
    <Item location="after" locateInMenu="auto" showText="always" visible={canUpdate} widget="dxButton"  options={btnSaveOptions} />
    <Item location="after" locateInMenu="auto" showText="always" visible={canAddNew} widget="dxButton"  options={btnAddNewOptions}/>
    <Item location="after" locateInMenu="auto" showText="always" visible={canRemove} widget="dxButton"  options={btnRemoveOptions}/>
    <Item location="after" locateInMenu="auto" showText="always"  widget="dxButton"  options={btnListOptions} />
    <Item location="after" locateInMenu="auto" showText="always" visible={canChoseColumn} widget="dxButton"  options={btnColumnChoserOptions} />
</Toolbar> 
) 
};
export default GridToolbar